import { ListItem } from "@tiptap/extension-list-item";
// types/custom-list-item.d.ts
import { ListItemOptions } from '@tiptap/extension-list-item'
import { KeyboardShortcutCommand } from "@tiptap/core";
declare module '@tiptap/extension-list-item' {
  interface ListItemOptions {
    maxLine?: number
    isShiftEnter?: boolean
  }
}

const CustomListItem = ListItem.extend({
  name: 'customListItem',
  addOptions() {
    return {
      ...this.parent?.(),
      maxLine: 0, // 默认值为0（不限制行数）
      isShiftEnter: true,
    };
  },
  addStorage() {
    return {
      getMaxLine: () => this.options.maxLine,
    };
  },
  addKeyboardShortcuts() {
    const parentShortcuts = this.parent?.() || {};
    // 获取当前列表项在其父列表中的位置（行数）
    const getCurrentLineNumber = (editor) => {
      let count = 0
      editor.state.doc.descendants((node, pos) => {
        if (node.type.name === 'listItem') {
          count++
        }
      });
      return count
    };
    return {
      Enter: ({ editor }) => {
        const { state } = editor.view;
        const { $from } = state.selection;
        const node = $from.parent;
        // 获取行数
        const lineCount = getCurrentLineNumber(editor);
        // 如果 maxLine >= 1，直接阻止回车换行
        if (this.options.maxLine && lineCount >= this.options.maxLine) {
          return true; // 返回 true 表示阻止默认行为
        }

        // 原有逻辑：检查列表项是否为空
        const isEmpty =
          node.content.size === 0 ||
          (node.content.firstChild?.isText &&
            node.content.firstChild.text.trim() === "");

        // 原有逻辑：检查是否有选中的文本
        const hasSelection = state.selection.empty === false;

        // 如果列表项为空或有选中文本，阻止回车
        if (isEmpty || hasSelection) {
          return true;
        }

        // 其他情况允许默认的回车行为
        return false;
      },
      // 阻止Shift+回车
      "Shift-Enter": ({ editor }: { editor }) => {
        const lineCount = getCurrentLineNumber(editor);

        // 检查是否超出最大行数或禁用 Shift+Enter 功能
        if (this.options.maxLine && lineCount >= this.options.maxLine || this.options.isShiftEnter === false) {
          return true; // 阻止默认行为
        }
        // 手动插入换行符
        const { tr } = editor.state;
        const { $from } = tr.selection;
        // 在当前位置插入换行符（使用一个空的文本节点来模拟折行）
        const breakNode = editor.schema.nodes.paragraph.create();
        tr.insert($from.pos, breakNode);
        const newPos = $from.pos + 1;
        // 提交修改
        editor.view.dispatch(tr);
        editor.commands.setTextSelection(editor.state.selection.constructor.near(tr.doc.resolve(newPos)));
        return true; // 阻止默认行为
      }

    };
  },
});

export default CustomListItem;